import http from "./http";
import { API_URL, USE_MOCK } from "./config";

const apiUrl = `${API_URL}setting`;

// Public site settings, same shape as dm-commerce-b2b-web's site-logo:
// { payload: { metakey, metavalue: "<url>", isActive } }.
// Resolves to the icon URL, or "" when the setting is missing/unreachable.
//
// The admin gateway has no public `setting/site-favicon` route yet (only `site-logo`; the
// request falls into the guarded `setting/:id` route and ends as a 500), so the tab icon
// comes from REACT_APP_FAV_LOGO. Set REACT_APP_FAVICON_API=true once the route exists.
export async function getSiteFavicon() {
  if (USE_MOCK || process.env.REACT_APP_FAVICON_API !== "true") return "";
  try {
    const { data } = await http.get(`${apiUrl}/site-favicon`);
    return data?.payload?.isActive === false ? "" : data?.payload?.metavalue || "";
  } catch {
    return "";
  }
}
